







































import { Vue, Component } from 'vue-property-decorator';

import mainSection from '@/components/page/MainSection.vue';
import aboutSection from '@/components/page/AboutSection.vue';
import featuresSection from '@/components/page/FeaturesSection.vue';
import stepSection from '@/components/page/StepSection.vue';
import serviceSection from '@/components/page/ServiceSection.vue';
import businessSection from '@/components/page/BusinessSection.vue';
import partnerSection from '@/components/page/PartnerSection.vue';
import contactSection from '@/components/page/ContactSection.vue';

@Component({
  name: 'Index',
  components: {
    mainSection,
    aboutSection,
    featuresSection,
    stepSection,
    serviceSection,
    businessSection,
    partnerSection,
    contactSection,
  },
})
/**
 * @vuese
 * @group Page/Index
 * Index page component
 */
export default class Index extends Vue {}
